function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import {useTranslation} from "../../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialCheckbox from "../../../../../__snowpack__/pkg/@mui/material/Checkbox.js";
import React, {useCallback} from "react";
import Button from "../../../atoms/button/button.component.js";
import Icon from "../../../atoms/icon/icon.component.js";
import Autocomplete from "../../../atoms/select/autocomplete/autocomplete.component.js";
import FormDrawer from "../../form-drawer/form-drawer.component.js";
function UnitMergeFilter({
  accountList,
  drawerOpen,
  groupList,
  initialValues,
  innerRef,
  loading,
  open,
  portfolioList,
  propertyList,
  onClose,
  onCloseAutocomplete,
  onOpenAutocomplete,
  onRefetchField,
  onReset,
  onSubmit
}) {
  const {
    t
  } = useTranslation();
  const handleRenderOption = useCallback((props, option, {
    selected
  }) => {
    return /* @__PURE__ */ React.createElement("li", _extends({}, props, {
      key: option.id
    }), /* @__PURE__ */ React.createElement(MaterialCheckbox, {
      icon: /* @__PURE__ */ React.createElement(Icon, {
        size: "medium"
      }, "check_box_outline_blank"),
      checkedIcon: /* @__PURE__ */ React.createElement(Icon, {
        size: "medium"
      }, "check_box"),
      style: {
        marginRight: 8
      },
      checked: selected
    }), option.label);
  }, []);
  return /* @__PURE__ */ React.createElement(FormDrawer, {
    drawerOpen,
    onClose,
    title: t("user.filter_by"),
    innerRef,
    initialValues,
    onSubmit,
    actions: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
      onClick: onReset
    }, t("actions.clear")), /* @__PURE__ */ React.createElement(Button, {
      type: "submit"
    }, t("actions.submit")))
  }, /* @__PURE__ */ React.createElement(Autocomplete, {
    label: t("user.filter.account"),
    name: "account",
    multiple: true,
    limitTags: 1,
    open: open.account || false,
    onOpen: () => onOpenAutocomplete("account"),
    onClose: () => onCloseAutocomplete("account"),
    loading: loading.account || false,
    refetchField: ["group", "portfolio", "property"],
    onRefetch: onRefetchField,
    options: accountList,
    getOptionLabel: (option) => option.label,
    isOptionEqualToValue: (option, value) => option.id === value.id,
    renderOption: handleRenderOption,
    disableCloseOnSelect: true
  }), /* @__PURE__ */ React.createElement(Autocomplete, {
    label: t("user.filter.portfolio"),
    name: "portfolio",
    multiple: true,
    limitTags: 1,
    open: open.portfolio || false,
    onOpen: () => onOpenAutocomplete("portfolio"),
    onClose: () => onCloseAutocomplete("portfolio"),
    loading: loading.portfolio || false,
    refetchField: ["property", "group"],
    onRefetch: onRefetchField,
    options: portfolioList,
    getOptionLabel: (option) => option.label,
    isOptionEqualToValue: (option, value) => option.id === value.id,
    renderOption: handleRenderOption,
    disableCloseOnSelect: true
  }), /* @__PURE__ */ React.createElement(Autocomplete, {
    label: t("user.filter.group"),
    name: "group",
    multiple: true,
    limitTags: 1,
    open: open.group || false,
    onOpen: () => onOpenAutocomplete("group"),
    onClose: () => onCloseAutocomplete("group"),
    loading: loading.group || false,
    refetchField: ["property"],
    onRefetch: onRefetchField,
    options: groupList,
    getOptionLabel: (option) => option.label,
    isOptionEqualToValue: (option, value) => option.id === value.id,
    renderOption: handleRenderOption,
    disableCloseOnSelect: true
  }), /* @__PURE__ */ React.createElement(Autocomplete, {
    label: t("user.filter.property"),
    name: "property",
    multiple: true,
    limitTags: 1,
    open: open.property || false,
    onOpen: () => onOpenAutocomplete("property"),
    onClose: () => onCloseAutocomplete("property"),
    loading: loading.property || false,
    options: propertyList,
    getOptionLabel: (option) => option.label,
    isOptionEqualToValue: (option, value) => option.id === value.id,
    renderOption: handleRenderOption,
    disableCloseOnSelect: true
  }));
}
export default /* @__PURE__ */ React.memo(UnitMergeFilter);
